import type { MfeNames } from '@/utils/domains.js';

/** Zone shells serve hubs and account schema from the app-shell GraphQL BFF. */
const GRAPHQL_PATH_ALIASES: Partial<Record<MfeNames, MfeNames>> = {
    hubs: 'app-shell',
    'ptv-appshell': 'app-shell',
    account: 'app-shell',
};

/** MFE whose deploy hosts the GraphQL BFF for `appName` (path + SSR origin). */
export const resolveGraphQLAppName = (appName: MfeNames): MfeNames =>
    GRAPHQL_PATH_ALIASES[appName] ?? appName;

/** Resolve the zone-relative GraphQL BFF path for an MFE name. */
export const getGraphQLPath = (appName: MfeNames) =>
    `/api/tn/${resolveGraphQLAppName(appName)}/graphql/`;
